











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NewMeetingTeamPicker_teams",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SelectTeamDropdown_teams"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node ).hash = "d2df8ea5edec97b463fd0e056b0d73e9";

export default node;
